export class gara{
    id:string;
    nome:string;
    data:string;
    n_bersagli:number;
    type:string;
    user_id;
    user_invited;
    admin;
    premio;
    archiviata:boolean;
    ordine:number;
}